import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const SampleContainer = styled(Box)(() => ({
  border: '1px solid #D7D8DB',
  backgroundColor: '#FFFFFF',
  padding: '32px 40px',
  marginTop: '40px',
}));

export const LabelBox = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
}));

export const IdLabel = styled(Box)(() => ({
  fontWeight: '600',
  fontSize: '21px',
  backgroundColor: '#ECF0F6',
  width: 180,
  height: 39,
  borderTopRightRadius: 8,
  borderBottomRightRadius: 8,
  color: '#2B3550',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  top: -32,
  left: -40,
}));

export const UnusedLabel = styled(Box)(({ theme }) => ({
  fontWeight: '600',
  fontSize: '18px',
  backgroundColor: '#78909C',
  color: theme.palette.common.white,
  borderRadius: '2px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  padding: '0 20px',
  top: -32,
}));

export const EmptyBox = styled(Box)(() => ({
  width: 180,
  position: 'relative',
  top: -32,
  right: -40,
}));

export const InputTitle = styled(Typography)(() => ({
  paddingBottom: '4px',
  fontSize: '14px',
}));

export const StyledInput = styled(Typography)(() => ({
  fontWeight: '600',
  fontSize: '18px',
  borderBottom: '1px solid #8B8C8E',
  inlineSize: 'fit-content',
  minWidth: '100px',
  padding: '0 8px',
  minHeight: '28px',
}));

export const SectionBox = styled(Box)(() => ({
  margin: '40px 0',
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '21px',
  fontWeight: '600',
  margin: '20px 0',
  cursor: 'pointer',
  '& span': { color: theme.palette.secondary.main },
}));

export const ElementButton = styled(Button)(({ theme }) => ({
  width: '100%',
  maxWidth: 210,
  height: 32,
  backgroundColor: theme.palette.common.white,
  fontSize: 15,
  fontWeight: '600',
  lineHeight: '20px',
  border: `2px solid ${theme.palette.secondary.main}`,
  borderRadius: 10,
  color: theme.palette.secondary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  cursor: 'pointer',
  '&:disabled': {
    opacity: '0.5',
    color: theme.palette.secondary.main,
  },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.secondary.main,
}));
